import { SessionConfigJSONv2 } from "../@types"
import { createDefaultsConfig, Defaults } from "./defaults"
import { createEndpointsConfig, Endpoints } from "./endpoints"
import { PageSettings } from "./pageSettings"
import { createSiteOwnerSettings, SiteOwnerSettings } from "./siteOwnerSettings"

export interface SessionConfig {
  siteOwnerSettings: SiteOwnerSettings
  beaconEndpointInfo: Endpoints
  dopplerClientDefaults: Defaults
}

export const createSessionConfig: (
  sessionConfigSource: SessionConfigJSONv2,
  pageSettings: PageSettings,
) => SessionConfig = (s, p) => new SessionConfigImpl(s, p)

class SessionConfigImpl implements SessionConfig {
  private _clientDefaults: Defaults
  private _clientEndpoints: Endpoints
  private _siteOwnerSettings: SiteOwnerSettings
  constructor(
    sessionConfigSource: SessionConfigJSONv2,
    pageSettings: PageSettings,
  ) {
    /* eslint-disable @typescript-eslint/dot-notation */
    // Hard-coded default of 1 second between measurements
    this._siteOwnerSettings = createSiteOwnerSettings(
      sessionConfigSource["bu_settings"],
      pageSettings,
    )
    this._clientEndpoints = createEndpointsConfig(
      sessionConfigSource["endpoints"],
      pageSettings,
    )
    // Provide a sensible default in case the client obtains an
    // old sessconf that lacks the `defaults` object.
    this._clientDefaults = createDefaultsConfig(
      sessionConfigSource["defaults"] || {
        platform: {
          hdx: true,
        },
      },
    )
    /* eslint-enable @typescript-eslint/dot-notation */
  }

  get siteOwnerSettings() {
    return this._siteOwnerSettings
  }

  get beaconEndpointInfo() {
    return this._clientEndpoints
  }

  get dopplerClientDefaults() {
    return this._clientDefaults
  }
}
